module.exports = __webpack_public_path__ + "static/hackathon-meetup-c9cd27368c3e2afdac4a86b52acde31d.jpg";